export default {
  AB_TEST_ASSIGNMENT: 'AB test assignment',
  AGENCY_AVAILABILITY: 'Agency Availability',
  AGENCY_MSA_RATE: 'Agency MSA Rate',
  BATCH_MAILCHIMP: 'Batch Update Mailchimp Subscriptions',
  BATCH_USER_ACTIONS: 'Batch User Actions',
  BD_FRAUD: 'BD Self-Payout Fraud',
  BOOKING_BATCH_ACTIONS: 'Batch Bookings Actions',
  BOOKING_LOOKUP: 'Booking Lookup',
  CHAT_HISTORY: 'AI Chat History',
  COMPANIES: 'Companies',
  DUPLICATE_SITTERS: 'Resolve Duplicate Sitters',
  EMPLOYEES: 'Employees',
  GROUPS_AFFILIATIONS: 'Affiliations',
  GROUPS_COLLEGES: 'Colleges',
  GROUPS_LOCAL_GROUPS: 'Local Groups',
  GROUPS_SCHOOLS: 'Schools',
  INCLUDES: 'Includes',
  JOB_MODERATION: 'Job Moderation',
  KNOWLEDGE_DOCUMENTS: 'Knowledge Documents',
  MASTER_SERVICE_AREA_TIERS: 'Master Service Area Tiers',
  MASTER_SERVICE_AREAS: 'Master Service Areas',
  ORDER_LOOKUP: 'Order Lookup',
  ORDER_PAYOUT: 'Send Payout',
  ORDER_PAYOUT_DELAY: 'Delay Payouts',
  PARTNERS: 'Partners',
  PHOTO_MODERATION: 'Photo Moderation',
  PRESS: 'Press',
  PRICING_PLANS: 'Small Business Pricing Plans',
  QA_ACTIVITY_GENERATOR: 'Activity Generator',
  QA_API_PROFILER: 'API Profiler',
  QA_MEMBERSHIP_RENEWAL: 'Membership Renewal',
  QA_SEED_TEST_USER: 'Seed Test User',
  QA_SSO_TEST: 'SSO Test',
  RESET_USER_PASSWORDS: 'Reset User Passwords',
  RISK_REVIEW: 'Risk Review',
  SEO_CITY: 'Cities SEO',
  SEO_STATE: 'States SEO',
  SMALL_BUSINESS: 'Small Business',
  SPECIAL_EXPERIENCES: 'Special Experiences',
  SPECIAL_SERVICES: 'Special Services',
  SPECIAL_SITUATIONS: 'Special Situations',
  SWEETENERS: 'Sweeteners',
  TAGS: 'Tags',
  TXN_EMAIL_TEMPLATES: 'TXN Emails',
  USER_LOOKUP: 'User Lookup',
  VIDEO_MODERATION: 'Video Moderation',
  VOUCHER_ADD: 'Add Voucher',
  VOUCHER_LOOKUP: 'Voucher Lookup',
  WINBACK_CODE: 'Winback Codes',
  ZIP_CODE_LOOKUP: 'Zip Codes',
};
